






























import {Component, Prop} from 'vue-property-decorator';
import Select from '@/components/form/Select.vue';
import Input from '@/components/form/Input.vue';
import prefixes from '@/resources/phone-codes.json';
import ApiMixin, {ApiException} from '@/mixins/apiMixin';
import {mixins} from 'vue-class-component';

@Component({
	components: {
		'v-select': Select,
		'v-input': Input
	}
})
export default class PhoneSelect extends mixins(ApiMixin) {
	@Prop({default: null}) readonly variant?: string | null;
	@Prop({default: 'button.sendAppLink'}) buttonLabel: string;

	number: string = '';
	prefix: string = '';
	prefixes = prefixes;

	get variantClasses(): string[] {
		if (!this.variant) {
			return [''];
		}
		return this.variant.split(' ').map((variant) => {
			return `phone-select--${variant}`
		});
	}

	async sendForm() {
		const phone = {
			number: this.number,
			prefix: this.prefix,
		};

		try {
			const token = await this.recaptcha.execute();
			const canSubmit = await this.RecaptchaP({token: token});

			if (canSubmit.data.status === false) {
				return;
			}

			await this.GetAppP({phone, token});
			this.$emit('send');
		} catch (error) {
			this.catchException(error, (exception: ApiException) => {
				console.log(exception.message)
			});
		}
	}
}
